import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Zap } from 'lucide-react';
import { CART_LINK } from '../lib/constants';
export function FinalClose() {
  return <section className="py-24 bg-burgundy text-white px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-71">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=1600&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-72"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-74">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-10 leading-tight" data-id="element-75">
            Tu próximo periodo puede encontrarte preparada, no destruida
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-white/90 font-medium mb-12 max-w-2xl mx-auto text-left" data-id="element-76">
            <p className="flex items-start" data-id="element-77">
              <span className="text-gold mr-3 font-bold" data-id="element-78">—</span> No cuando ya
              estás hinchada, con dolor y agotada.
            </p>
            <p className="flex items-start" data-id="element-79">
              <span className="text-gold mr-3 font-bold" data-id="element-80">—</span> No cuando ya
              estás discutiendo con tu novio o sobrepensando todo.
            </p>
            <p className="flex items-start" data-id="element-81">
              <span className="text-gold mr-3 font-bold" data-id="element-82">—</span> No cuando ya
              comiste por ansiedad, dormiste mal y te sentís culpable.
            </p>
            <p className="flex items-start" data-id="element-83">
              <span className="text-gold mr-3 font-bold" data-id="element-84">—</span> No dejes que
              arruine tu productividad en el trabajo o la facultad y te tire a
              la cama.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 mb-12" data-id="element-85">
            <p className="text-2xl md:text-3xl font-serif font-bold text-gold mb-4" data-id="element-86">
              El cambio empieza antes.
            </p>
            <p className="text-lg text-white/90" data-id="element-87">
              Con 5 días. Con un plan. Con herramientas concretas. Con más
              calma. Con más claridad.
              <br data-id="element-88" />
              <br data-id="element-89" />
              <span className="font-bold text-xl" data-id="element-90">
                Para volver a sentir que tu cuerpo no está contra vos.
              </span>
            </p>
          </div>

          <a href="#value-stack" className="inline-block w-full md:w-auto bg-white text-burgundy hover:bg-gray-100 font-bold text-2xl py-5 px-12 rounded-xl shadow-[0_8px_30px_rgba(255,255,255,0.2)] transition-all transform hover:scale-105 mb-6" data-id="element-91">
            COMPRAR AHORA 70% OFF
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-white/70 font-medium" data-id="element-92">
            <span className="flex items-center" data-id="element-93">
              <ShieldCheck className="w-4 h-4 mr-1" data-id="element-94" /> Pago seguro
            </span>
            <span data-id="element-95">·</span>
            <span className="flex items-center" data-id="element-96">
              <CreditCard className="w-4 h-4 mr-1" data-id="element-97" /> Mercado Pago / Tarjetas
            </span>
            <span data-id="element-98">·</span>
            <span className="flex items-center" data-id="element-99">
              <Zap className="w-4 h-4 mr-1" data-id="element-100" /> Acceso inmediato
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}